import {Typography, Button} from "@material-ui/core";
import React, {Component, Fragment} from "react";
import {withStyles} from "@material-ui/core";
import {useStyles} from '../../common/styles'
import {ContainerRowStart, ItemSimple, PaperAfterContainer} from "../abstractions";


export default withStyles(useStyles)(class Consultancy extends Component {
    handleAlert=()=>{
        alert("Menu contextuel!");
        return false;
    };
       render(){
          const {classes} = this.props;
        return (
            <Fragment>
                <Typography variant={'overline'} onContextMenu={this.handleAlert} align={'center'} className={classes.mar}>
                    thought I could contribute, share my skills and knowledge with your team?
                </Typography>
                <ContainerRowStart spacing={32} className={classes.mar}>
                    <ItemSimple>
                        <PaperAfterContainer className={classes.pad}>
                            <Typography variant={'overline'} inline={true} color={'default'}>
                               want to hire me for specific tasks or fulltime job?
                            </Typography>
                            <Typography variant={'body2'}>
                               Feel free to take a look at my portfolio, any time.
                            </Typography>
                              <Button variant={'contained'} size={'medium'} fullWidth={false} color={'secondary'} align={'center'} className={classes.mar} href={'https://portfolio.monquo.studio'} download={true} target={'_blank'}>
                                See my Portfolio
                              </Button>
                        </PaperAfterContainer>
                    </ItemSimple>
                </ContainerRowStart>
            </Fragment>
        )
    }
})

